/**
 * Sends authentication info to Lockdown
 */
export function sendLockdownAuthentication({ refreshToken, accountId }: { refreshToken?: string; accountId?: string }) {
	console.log("Sending authentication info to Lockdown/mobile...");
	window.top?.postMessage(
		{
			subject: "__VERITY_AUTH",
			payload: { refreshToken, accountId },
		},
		"*",
	);
}
